/**
 * ConfidenceBadge Component
 * Phase 3.7 - Displays confidence level for interpretation sections
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Shield } from 'lucide-react';

const CONFIDENCE_LABELS = {
  high: { tr: 'Yüksek Gözlem Güveni', en: 'High Observation Confidence' },
  medium: { tr: 'Orta Gözlem Güveni', en: 'Medium Observation Confidence' },
  low: { tr: 'Sınırlı Gözlem Güveni', en: 'Limited Observation Confidence' }
};

const ConfidenceBadge = ({ confidence, confidenceDetails, lang = 'tr' }) => {
  // Calculate level from confidence_details or raw confidence score
  const level = confidenceDetails?.level || 
    (confidence >= 0.8 ? 'high' : confidence >= 0.6 ? 'medium' : 'low');
  
  const label = CONFIDENCE_LABELS[level]?.[lang] || CONFIDENCE_LABELS[level]?.tr;
  
  return (
    <span 
      className={`confidence-badge-new confidence-${level}`}
      title={label}
    >
      <Shield size={12} />
      {label}
    </span>
  );
};

ConfidenceBadge.propTypes = {
  confidence: PropTypes.number,
  confidenceDetails: PropTypes.shape({
    score: PropTypes.number,
    level: PropTypes.oneOf(['high', 'medium', 'low']),
    source_count: PropTypes.number
  }),
  lang: PropTypes.string
};

export default ConfidenceBadge;
